import { useFormikContext } from "formik";
import React from "react";
import CustomPhoneInput from "react-phone-input-2";
import styles from "../TextField/TextField.module.css";
import PhoneInputStyles from "./PhoneInput.module.css";
import { labelName } from "../../../utils/functions";
import ErrorMessage from "../ErrorrMessage";
import getLocationCountry from "../../../utils/functions/getLocationCountry";

const PhoneInput = ({ field_label, field_type, parent, isRequired }) => {
  const { setFieldValue, values, handleBlur } = useFormikContext();
  const name = parent ? `${parent}.fields.${field_label}` : field_label;



  return (
    <div className={styles.inputContainer}>
      <label className={styles.label}>
        {labelName(field_label)}
        {isRequired === "true" && (
          <span style={{ color: "#d32f2f", padding: 0 }}>*</span>
        )}
      </label>
      <CustomPhoneInput
        country={getLocationCountry()}
        value={values[name]}
        onChange={(phone) => {
          setFieldValue(name, phone);
        }}
        inputClass={PhoneInputStyles.input}
        inputProps={{
          name,
          onBlur: handleBlur,
          maxLength :18
        }}
        copyNumbersOnly
        enableLongNumbers
      />
      <ErrorMessage name={name} parent={parent} />
    </div> 
  );
};

export default PhoneInput;
